import React from 'react';
import EnterprisePage from '@/components/Pages/EnterprisePage';

export default function Enterprise() {
  return <EnterprisePage />;
}
